/**
 * @file This file contains the definitions for automated achievement tests.
 * @module achievementTests
 */

export const achievementTests = [
    {
        id: 'test-first-gold',
        name: 'First Gold',
        description: 'Tests if the "First Gold" achievement triggers when gold is earned for the first time.',
        run: async ({ eventEmitter, expectToast }) => {
            eventEmitter.emit('achievement:goldUpdated', { newGoldTotal: 1 });
            await expectToast('FIRST_GOLD');
        }
    },
    {
        id: 'test-double-merge',
        name: 'Chain Reaction (Double Merge)',
        description: 'Tests if the "Chain Reaction" achievement triggers on a double merge.',
        run: async ({ eventEmitter, expectToast }) => {
            const mockGameState = {
                isCampaignLevel: true,
                activeGameConfig: { gameMode: 'linear' },
                incrementSessionMerges: () => {},
                getSessionMerges: () => 0
            };
            eventEmitter.emit('achievement:mergeOccurred', { consecutiveCount: 2, gameState: mockGameState, row: 0, col: 0 });
            await expectToast('DOUBLE_MERGE');
        }
    },
    {
        id: 'test-perfect-cleanup',
        name: 'Perfect Placement (Power-up)',
        description: 'Tests if the "Perfect Placement" achievement triggers when a clean-up clears 9 cells.',
        run: async ({ eventEmitter, expectToast }) => {
            eventEmitter.emit('achievement:perfectPowerup', { powerupKey: 'powerup_cleanup', cellsCleared: 9, row: 1, col: 1 });
            await expectToast('PERFECT_CLEANUP');
        }
    },
    {
        id: 'test-lucky-win',
        name: 'A Quiet Day (Lucky Win)',
        description: 'Tests if the "A Quiet Day" achievement triggers when winning with zero disasters.',
        run: async ({ eventEmitter, expectToast }) => {
            const mockGameState = {
                isCampaignLevel: true,
                disastersSurvived: 0, // This is the condition we are testing for
                cratesBuilt: 1,      // Set to non-zero to prevent 'Pacifist' from triggering
                powerupsUsed: 1,     // Set to non-zero to prevent 'Natural Talent' from triggering
                activeGameConfig: {
                    gameMode: 'linear'
                }
            };
            eventEmitter.emit('achievement:levelWon', { gameState: mockGameState, levelIndex: 1 });
            await expectToast('LUCKY_WIN');
        }
    }
    // Add more test cases here in the future
];